export enum ESolutionTabKey {
  ALL = "all",
  VULNSCAN = "vulnscan",
  SECURITY_OPERATION = "security_operation",
  DATA_SECURITY = "data_security",
  SECURITY_COMPLIANCE = "security_compliance",
}

export enum ESolutionKey {
  SECRETS_MANAGER = "secretsManager",
  PASSWORD_MANAGER = "passwordManager",
  ENDPOINT = "endpoint",
  DATA_LEAK = "data_leak",
  VULN_SCAN = "vuln_scan",
  TRUST_CENTER = "trust_center",
  PENETRATION_TESTING = "penetration_testing",
  RED_TEAMING = "red_teaming",
  CLOUD_SECURITY_AUDIT = "cloud_security_audit",
  SOURCE_CODE_AUDIT = "source_code_audit",
  BLOCKCHAIN_PROTOCOL_AUDIT = "blockchain_protocol_audit",
  WHITEHUB_BUG_BOUNTY = "whitehub_bug_bounty",
  SECURITY_COMPLIANCE = "security_compliance",
  SECURITY_OPERATIONS_CENTER = "security_operations_center",
  VULNERABILITY_MANAGEMENT = "vulnerability_management",
}
